import React from 'react';
import MarketingManager from './components/MarketingManager';
import AboutTheJob from './components/AboutTheJob';
import Resposibilities from './components/Resposibilities';
import ApplicationForm from './components/ApplicationForm';
import NewsLetter from './components/NewsLetter';
import { Footer } from '../../Components/Footer';
import HeaderAlt from '../../Components/HeaderAlt';

const JobDescriptionPage = () => {
  return (
    <>
      <HeaderAlt />
      <div className="container !px-6">
        <div className="font-fredoka mt-[10px] flex items-center space-x-2 text-[18px] font-normal leading-[24px] tracking-[-0.18px] text-[#5AC4CF]">
          <a href="/" className="hover:underline">
            Home
          </a>
          <span className="text-[#678285]">/</span>
          <a href="/careers" className="hover:underline">
            Careers
          </a>
          <span className="text-[#678285]">/</span>
        </div>

        <div className="mt-10 flex flex-col gap-5 lg:flex-row">
          <div className="mb-5  w-full sm:w-full md:mb-0 lg:w-[818px]">
            {' '}
            {/* For smaller and medium screens */}
            <MarketingManager />
            <hr className="mt-4 md:mt-6" />
            <div className="mt-[14px] md:!mt-6">
              <AboutTheJob />
            </div>
            <div className="mt-6 md:mt-8">
              <Resposibilities />
            </div>
            <div className="mt-[42px]" id="hellomom">
              <ApplicationForm />
            </div>
          </div>

          <div className="hidden w-full lg:block lg:w-[397px]">
            <NewsLetter />
          </div>
        </div>
      </div>

      <div className="mt-14">
        <Footer />
      </div>
    </>
  );
};

export default JobDescriptionPage;
